import type { ListBuilderList } from '../../../types';
import { BASE_FILTER_RULES, TRANSACTION_REQUIRED_FIELDS } from '../shared';

/**
 * PD-14977 — Open Authorizations: money held on a customer's card that was
 * never collected.
 *
 * An approved authorization reads as a success everywhere else in the UI, so
 * held funds are invisible until they lapse and become uncollectable. Motor
 * City Ice had 17 of these worth $3,682.61 before anyone noticed, and finding
 * them meant hand-building a filter that could not be built at all until the
 * settled flag was exposed.
 *
 * Oldest first: an authorization's value decays: issuers release the hold
 * after days to weeks, so the top of this list is the money most likely to be
 * lost.
 */
export const openAuthorizationsList: ListBuilderList = {
	id: 'default-transaction-open-authorizations',
	inheritsFrom: 'default-transaction-all',
	cacheTTL: 300000,
	name: 'Open Authorizations',
	type: 'default',
	active: true,
	sortOrder: 6,
	description:
		'Card authorizations that were approved but never captured — money held, not collected. Oldest first.',
	defaultSortId: 'column-transaction-dates-asc',
	requiredFields: TRANSACTION_REQUIRED_FIELDS,
	filterRules: {
		...BASE_FILTER_RULES,
		transactionType: {
			defaultValue: [{ id: 'Authorization', label: 'Authorization' }],
		},
		// '0', not 'false' — the id is compared against a tinyint column; see
		// the note on the transactionFundsCollected filter definition.
		transactionFundsCollected: {
			defaultValue: [{ id: '0', label: 'Pending settlement' }],
		},
		// Approved authorizations only. A FAILED authorization is also
		// unsettled, but it never held anything — listing it here would pad a
		// view whose entire purpose is "money currently held on a customer's
		// card". 'Processing' is the approved state for an authorization;
		// 'Succeeded' covers gateways that report it that way.
		transactionStatus: {
			defaultValue: [
				{ id: 'Processing', label: 'Processing' },
				{ id: 'Succeeded', label: 'Succeeded' },
			],
		},
	},
};
